<template>
  <div class="hello">
    <div class="header">
      <div class="top">
        <a href="/" class="logo"></a>
        <img class="logo_game" src="../assets/logo_game.jpg" alt="">
        <ul class="nav">
          <li class="active"><a @click="$router.push('/about')">平台首页</a></li>
          <li><a @click="$router.push('/about')">关于我们</a></li>
          <li><a @click="$router.push('/game')">开始游戏</a></li>
          <li><a @click="$router.push('/pay')">支付</a></li>
        </ul>
      </div>
    </div>
    <div class="banner swiper-container">
      <swiper :options="swiperOption">
        <swiper-slide><img class="cu" src="../assets/banner-01.jpg" alt=""></swiper-slide>
        <!-- <swiper-slide><img class="cu" src="../assets/banner-02.jpg" alt=""></swiper-slide> -->
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="info">
      <div class="item itemTa clearfix">
        <div class="xtitle"><span>游戏公告</span></div>
        <div class="news">
          <a href="javascript:;" class="hot">《守护者之森》荣耀九区②组【纵横天下】今日开启</a>
          <ul class="newsList">
            <li><a href="javascript:;">《守护者之森》周年新大区今日江湖再续</a><em>2025/02/25</em></li>
            <li><a href="javascript:;">《守护者之森》周年新大区预约开启</a><em>2025/02/23</em></li>
            <li><a href="javascript:;">《守护者之森》周年新服激情再续</a><em>2025/02/21</em></li>
            <li><a href="javascript:;">《守护者之森》“齐天大圣”专区开启</a><em>2025/02/21</em></li>
            <li><a href="javascript:;">《守护者之森》十周年狂欢盛典开启</a><em>2025/02/20</em></li>
            <li><a href="javascript:;">《守护者之森》荣耀八区新服今日开启</a><em>2025/02/20</em></li>
            <li><a href="javascript:;"> 《守护者之森》十一周年新服即将开启</a><em>2025/02/17</em></li>
            <li><a href="javascript:;">《守护者之森》纵横江湖，新服今日开启！</a><em>2025/02/16</em></li>
            <li><a href="javascript:;">《守护者之森》【佳偶天成】今日火爆开启</a><em>2025/02/15</em></li>
          </ul>
        </div>
        <div class="xtitle right"><span>热门游戏</span></div>
        <div class="sbanner">
          <div class="swiper-container">
            <swiper :options="swiperOption">
              <!-- <swiper-slide><img class="cu" src="../assets/banner-small-01.png" alt=""></swiper-slide> -->
              <swiper-slide><img class="cu" src="../assets/banner-small-02.jpg" alt=""></swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
      <!-- <div class="item itemTb clearfix">
        <div class="xtitle"><span>游戏列表</span></div>
        <div class="gameA">
          <ul class="gameList">
            <li class="popAlert">
              <p class="img"><img src="../assets/qjfmlgame.jpg" alt=""></p>
              <div class="box">
                <p class="t3">
                  <span class="check" @click="showMask = true">查看详情</span>
                  <i></i>
                </p>
              </div>
            </li>
            <li>
              <p class="img"><img src="../assets/tzjgame.png" alt=""></p>
              <div class="box">
                <p class="t3">
                  <span class="check" @click="showMask1 = true">查看详情</span>
                  <i></i>
                </p>
              </div>
            </li>
            <li>
              <p class="img"><img src="../assets/smgame.png" alt=""></p>
              <div class="box">
                <p class="t3">
                  <span class="check" @click="showMask2 = true">查看详情</span>
                  <i></i>
                </p>
              </div>
            </li>
            <li>
              <p class="img"><img src="../assets/zxygame.jpg" alt=""></p>
              <div class="box">
                <p class="t3">
                  <a href="javascript:;">敬请期待</a>
                  <i></i>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <div v-if="showMask">
      <div class="mask" @click="showMask = false"></div>
      <div class="pop pop-download">
        <div class="close" @click="showMask = false"></div>
        <div class="pop-middle clearfix">
          <div class="pop-title">《琴剑封魔录》</div>
          <p>软著单位：成都雨墨科技有限公司</p>
          <p>出版单位：上海绿岸网络科技股份有限公司</p>
          <p>运营单位：上海绿岸网络科技股份有限公司</p>
          <p>ISBN 号：ISBN 978-7-7979-2309-5</p>
          <p>审批文号：新广出审[2016]3718号</p>
          <div @click="downloadBtn" class="downloadBtn">下载游戏</div>
        </div>
      </div>
    </div>
    <div v-if="showMask1">
      <div class="mask" @click="showMask1 = false"></div>
      <div class="pop pop-download">
        <div class="close" @click="showMask1 = false"></div>
        <div class="pop-middle clearfix">
          <div class="pop-title">《神圣之门》</div>
          <p>软著单位：上海绿岸网络科技股份有限公司</p>
          <p>出版单位：上海绿岸网络科技股份有限公司</p>
          <p>运营单位：上海绿岸网络科技股份有限公司</p>
          <p>ISBN 号：ISBN 978-7-498-07459-1</p>
          <p>审批文号：国新出审[2020]539号</p>
          <div @click="downloadBtn1" class="downloadBtn">下载游戏</div>
        </div>
      </div>
    </div>
    <div v-if="showMask2">
      <div class="mask" @click="showMask2 = false"></div>
      <div class="pop pop-download">
        <div class="close" @click="showMask2 = false"></div>
        <div class="pop-middle clearfix">
          <div class="pop-title">《守护者之森》</div>
          <p>软著单位：上海绿岸网络科技股份有限公司</p>
          <p>出版单位：上海绿岸网络科技股份有限公司</p>
          <p>运营单位：上海绿岸网络科技股份有限公司</p>
          <p>ISBN 号：ISBN 978-7-7979-5156-2</p>
          <p>审批文号：新广出审[2017]1662号</p>
          <div @click="downloadBtn2" class="downloadBtn">下载游戏</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="foot">
        <div class="fl"><a href=""><img style="width:200px" src="../assets/logo.jpg" alt=""></a></div>
        <div class="fr">
          <p>健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排 时间享受健康生活</p>
          <p>ICP 备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">琼ICP备19004874号-1</a></p>
          <p>公司名称：海南丰际网络科技有限公司</p>
          <p>公司地址：海南省澄迈县老城镇高新技术产业示范区海南生态软件园A17幢二层4001室</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {
      showMask: false,
      showMask1: false,
      showMask2: false,
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    downloadBtn () {
      window.location.href = 'https://down.yxzu.com/tf/msg_jc/66_158_1_1052.apk'
    },
    downloadBtn1 () {
      window.location.href = 'https://down.yxzu.com/tf/landing/89_575_2_1001.apk'
    },
    downloadBtn2 () {
      window.location.href = 'https://down.yxzu.com/tf/landing/89_541_2_1001.apk'
    }
  }
}
</script>
<style scoped>
ul,
li {
  list-style: none;
}
.logo_game{
  height: 50%;
    position: relative;
    top: 39%;
    left: 15px;
}
.cu{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue